import React, { Component } from 'react'
import { EMPTY_FIELD } from '@constants'

export default class ExtraInfo extends Component {
  render() {
    const { name, value } = this.props

    return (
      <div className='extra-info'>
        <div>
          <strong>Name:</strong>
          {name}
        </div>
        <div>
          <strong>Visible If:</strong>
          {value || EMPTY_FIELD}
        </div>
      </div>
    )
  }
}
